<template>
  <div>
    <a-modal
      title="Select OTP Verification Method"
      v-model:visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onSubmit"
      html-type="submit"
      @cancel="$emit('close', true)"
      footer=""
      width="400px"
      class="otp-selection-modal"
    >
      <a-form
        layout="vertical"
        :model="form"
        :rules="rules"
        name="OTPSelection"
        class="user-form"
        @finish="onSubmit"
      >
        <div class="form-check">
          <div class="radio-container">
            <input
              class="form-check-input"
              type="radio"
              value="email"
              id="Email"
              v-model="form.otp_method"
              required
            />
            <label class="form-check-label" for="Email">
              <i class="bi bi-envelope email-icon"></i>
              Email
            </label>
          </div>
          <div class="radio-container">
            <input
              class="form-check-input"
              type="radio"
              value="googleAuth"
              id="GoogleAuth"
              v-model="form.otp_method"
              required
            />
            <label class="form-check-label" for="GoogleAuth">
              <img alt="logo" class="google-auth-logo" :src="logo" />
              Google Authenticator App
            </label>
          </div>

          <!-- <input
            class="form-check-input"
            type="radio"
            value="phone"
            id="Phone Number"
            v-model="form.otp_method"
          />
          <label class="form-check-label" for="Phone Number">
            Phone Number
          </label>
          <br /> -->
        </div>
        <div class="buttons-w mt-2">
          <a-button
            type="primary"
            size="medium"
            html-type="submit"
            class="btn-block"
          >
            Done
          </a-button>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ref } from 'vue';
import logo from '../../assets/img/google-authenticator.png';

export default {
  data() {
    return {
      form: {
        otp_method: '',
      },
    };
  },
  created() {
    this.form.otp_method = this.receiveOtpOn || 'email';
  },
  emits: ['close'],
  setup() {
    const confirmLoading = ref(false);
    const visible = ref(true);
    const rules = {
      otp_method: [
        {
          required: true,
          trigger: 'submit',
          message: 'Please select an OTP method',
        },
      ],
    };
    return { confirmLoading, visible, rules, logo, };
  },
  computed: {
    ...mapGetters(['receiveOtpOn']),
  },
  methods: {
    ...mapActions(['setOTPMethod']),
    onSubmit() {
      if (
        this.setOTPMethod({
          receive_otp_on: this.form.otp_method,
        })
      ) {
        this.visible = false;
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<style scoped>
.otp-selection-modal {
  max-width: 400px;
  margin: auto;
}

.user-form {
  width: 100%;
  margin-top: 0;
}

.radio-container {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
}

.form-check-input {
  margin-right: 12px;
  cursor: pointer;
}

.email-icon {
  font-size: 26px;
  color: #1890ff;
  margin-right: 15px;
  margin-left: 5px;
}

.google-auth-logo {
  width: 28px;
  height: 28px;
  margin-right: 14px;
  margin-left: 3px;
}

.form-check-label {
  font-size: 16px;
  margin: 0;
  cursor: pointer;
}

.buttons-w {
  margin-top: 20px;
  text-align: center;
}

.btn-block {
  width: 100%;
}
</style>

<style>
.otp-selection-modal .ant-modal-header {
  background-color: #1890ff;
}
.otp-selection-modal .ant-modal-title {
  color: white;
  font-weight: bold;
}
</style>
